export function select(element) { return document.querySelector(element)};
export function selectAll(element) { return document.querySelectorAll(element)};

export function activeLoading() { select('.loading').classList.add('active') };
export function disableLoading() { select('.loading').classList.remove('active') };

export function addAtt(elementItem, attribute, value = '') { select(elementItem).setAttribute(attribute, value) }
export function removeAtt(elementItem, attribute) { select(elementItem).removeAttribute(attribute) }

export function outsideClick(element, callback) {
    const html = document.documentElement;
    const dataOutside = 'data-outside';

    if(!element.hasAttribute(dataOutside)) {
    // setTimeout sendo executado depois da fase bubble
      setTimeout(() => html.addEventListener('click', handleOutiseClick));
      element.setAttribute(dataOutside, '');
    }

    function handleOutiseClick(event) {
      if(!element.contains(event.target)) {
        element.removeAttribute(dataOutside);
        html.removeEventListener('click', outsideClick)
        callback();
      }
    }
}
